import styled, { css } from 'styled-components';
import spinKeyframes from '../../styles/spinKeyframes';
var IconContainer = styled.span.withConfig({
  displayName: "IconContainer",
  componentId: "sc-1u6ownu-0"
})(["display:flex;", ""], function (_ref) {
  var spin = _ref.spin;
  return spin && css(["animation:", " 1.5s infinite linear;"], spinKeyframes);
});
export default IconContainer;